import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "../api";
import SEO from "./SEO";

/** Client-side counterpart of the server's exact legacy URL resolver. */
export default function SmartRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState("loading");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setState("loading");
    // Unknown application paths are a real missing page. Do not interpret city
    // names or campaign query values as permission to redirect to a rental URL.
    if (!/^\/(product|category|copier)(\/|$)/.test(location.pathname)) {
      setState("missing");
      return () => { active = false; };
    }
    api.get("/api/seo/legacy-resolve", {
      params: { path: location.pathname },
      timeout: 10000,
    }).then(({ data }) => {
      if (!active) return;
      const target = data?.target;
      if (typeof target === "string" && /^\/(p\/[^/?#]+|store(?:\/[a-z-]+)?)$/.test(target)) {
        navigate(target, { replace: true });
      } else {
        setState("missing");
      }
    }).catch(() => {
      if (active) setState("error");
    });
    return () => { active = false; };
  }, [location.pathname, navigate, attempt]);

  const title = state === "loading" ? "페이지를 확인하고 있습니다"
    : state === "error" ? "페이지를 불러오지 못했습니다" : "페이지를 찾을 수 없습니다";

  return (
    <section style={{ padding: "48px 24px", maxWidth: 640, margin: "0 auto", lineHeight: 1.7 }}>
      <SEO title={`${title} | 일광오피스`} path={location.pathname} noindex />
      <h1 style={{ fontSize: 24, marginBottom: 16 }}>{title}</h1>
      <p role="status">
        {state === "loading" ? "이전 주소와 연결된 상품이 있는지 확인하고 있습니다."
          : state === "error" ? "잠시 후 다시 시도해 주세요."
            : "주소가 변경되었거나 더 이상 제공되지 않는 페이지입니다."}
      </p>
      {state === "error" && <button type="button" onClick={() => setAttempt(value => value + 1)}
        style={{ padding: "12px 16px", marginTop: 16 }}>다시 시도</button>}
      {state !== "loading" && <nav aria-label="다른 페이지"
        style={{ display: "flex", flexWrap: "wrap", gap: 20, marginTop: 24, color: "#1a4b8f" }}>
        <Link to="/">홈</Link><Link to="/store">상품 보기</Link>
        <Link to="/rental">복합기 렌탈</Link><Link to="/consultation">상담하기</Link>
      </nav>}
    </section>
  );
}
